import React from 'react';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { BarChart, Bar, PieChart, Pie, Cell, Tooltip, Legend, XAxis, YAxis } from 'recharts';

const GET_ANALYTICS = gql`
  query GetAnalytics {
    getAnalytics {
      total_customers
      event_orders
      total_orders
    }
  }
`;

const Dashboard = () => {
  const { loading, error, data } = useQuery(GET_ANALYTICS);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const analytics = data.getAnalytics;

  const chartData = [
    { name: 'Customers', value: analytics.total_customers },
    // { name: 'C Orders', value: analytics.corporate_orders },
    { name: ' Orders', value: analytics.event_orders },
    { name: 'Total Orders', value: analytics.total_orders },
  ];

  return (
    <div>
      {/* Analytics Overview */}
      <section className="grid grid-cols-4 gap-6 mb-8">
        <div className="bg-white p-4 shadow rounded">
          <p className="text-gray-500">Total Customers</p>
          <h2 className="text-2xl font-bold">{analytics.total_customers}</h2>
        </div>
        {/* <div className="bg-white p-4 shadow rounded">
          <p className="text-gray-500">Corporate Orders</p>
          <h2 className="text-2xl font-bold">{analytics.corporate_orders}</h2>
        </div> */}
        <div className="bg-white p-4 shadow rounded">
          <p className="text-gray-500">Orders</p>
          <h2 className="text-2xl font-bold">{analytics.event_orders}</h2>
        </div>
        <div className="bg-white p-4 shadow rounded">
          <p className="text-gray-500">Total Orders</p>
          <h2 className="text-2xl font-bold">{analytics.total_orders}</h2>
        </div>
      </section>

      {/* Graphs */}
      <section className="mb-8">
        <h3 className="text-lg font-bold mb-4">Analytics Graphs</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Bar Chart */}
          <div className="bg-white p-4 shadow rounded">
            <BarChart width={400} height={300} data={chartData}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#8884d8" />
            </BarChart>
          </div>

          {/* Pie Chart */}
          <div className="bg-white p-4 shadow rounded">
            <PieChart width={500} height={300}>
              <Pie data={chartData} dataKey="value" nameKey="name" outerRadius={100} fill="#8884d8" label>
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={['#0088FE', '#00C49F', '#FFBB28', '#FF8042'][index]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;